import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Errors, Control } from 'forms/rrf';
import BsCheckbox from '../elements/bs-checkbox';

class CommunicationPreferences extends Component {
  componentDidMount() {
    this.setErrors();
  }

  componentDidUpdate() {
    this.setErrors();
  }

  componentWillUnmount() {
    const { dispatch, model } = this.props;
    dispatch(actions.setErrors(`${model}.comms_mobile`, {
      required: false
    }));
  }

  setErrors = () => {
    const {
      dispatch, model, commsEmail, commsMobile, marketing
    } = this.props;
    dispatch(actions.setErrors(`${model}.comms_mobile`, {
      required: (!commsEmail && !commsMobile) && marketing === 'true'
    }));
  };

  render() {
    const { model } = this.props;
    return (
      <div>
        <label>How would you like us to contact you?</label>
        <br/>

        <Control.checkbox
          model={`${model}.comms_email`}
          component={BsCheckbox}
        >
          Email
        </Control.checkbox>
        <Control.checkbox
          model={`${model}.comms_mobile`}
          component={BsCheckbox}
        >
          Mobile
        </Control.checkbox>
        <Errors
          className="errors"
          model={`${model}.communication_preference`}
          show
        />

      </div>
    );
  }
}

export default connect()(CommunicationPreferences);
